/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {maybeMigrateSavingsV2} from '../api'

export const useMutationMaybeMigrateSavingsV2 = createReactQueryMutationHook('maybeMigrateSavingsV2', maybeMigrateSavingsV2)
